import { KatalComponent, nextUniqueId } from '../../shared/base';

/**
 * @component {kat-toggle} KatalToggle A toggle allows the customers to turn things on or off.
 * @guideline Do Only use for binary states such as on/off, visible/hidden, and enabled/disabled.
 * @guideline Dont Do not use toggles for selecting between two choices, for example, red/green; in this case, radio buttons should be used.
 * @event changed This event is fired whenever the toggle is clicked
 * @status Production
 * @theme flo
 */
class KatalToggle extends KatalComponent {
  static get observedAttributes() {
    return ['disabled', 'toggled'];
  }

  constructor() {
    super(KatalToggle.observedAttributes);
    this.uniqueId = nextUniqueId();
    this.value = this.toggled;
  }

  connectedCallback() {
    this.fullRender();
    super.connectedCallback();
  }

  /**
   * @param {boolean} toggled Tell the toggle to toggle or not to toggle, that is the questions.
   *
   */
  get toggled() {
    return this.getBooleanAttribute('toggled');
  }

  set toggled(value) {
    this.setBooleanAttribute('toggled', value);
  }

  /**
   * @param {boolean} disabled Sets the toggle switch to disabled state
   */
  get disabled() {
    return this.getBooleanAttribute('disabled');
  }

  set disabled(value) {
    this.setBooleanAttribute('disabled', value);
  }

  fullRender() {
    if (!this._rendered) {
      this.innerHTML = `
                <div class="toggle-container" ${
                  this.disabled ? 'disabled' : ''
                }>
                <label class="switch" for="${this.uniqueId}">
                    <input type="checkbox" id="${this.uniqueId}"  ${
        this.disabled ? 'disabled' : ''
      }/>
                    <div class="slider round"></div>
                </label>
                </div>
            `;

      this.querySelector('input').checked = this.toggled;

      this.createEvents();
      this._rendered = true;
    }
  }

  partialRender(attribute, value) {
    const toggled = this.toggled;
    if (attribute === 'disabled') {
      if (this.disabled) {
        this.querySelector('.toggle-container').setAttribute(attribute, value);
        this.querySelector('input').setAttribute(attribute, value);
      } else {
        this.querySelector('.toggle-container').removeAttribute(attribute);
        this.querySelector('input').removeAttribute(attribute);
      }
    } else if (attribute === 'toggled') {
      this.value = toggled;
      this.querySelector('input').checked = toggled;
    }

    const event = new CustomEvent('changed', {
      detail: { toggled: toggled },
    });
    this.dispatchEvent(event);
  }

  createEvents() {
    this.querySelector('input').onclick = e => {
      e.stopPropagation();
      e.preventDefault();
    };

    this.addEventListener('click', () => {
      if (!this.disabled) {
        this.toggled = !this.toggled;
      }
    });
  }

  // Respond to attribute changes.
  attributeChangedCallback(attr, oldValue, newValue) {
    this.fullRender();
    this.partialRender(attr, newValue);
  }
}

KatalComponent.register('kat-toggle', KatalToggle);
